module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded),
      expression: "pageLoaded"
    }],
    staticClass: "flex-content"
  }, [(_vm.subOrderId > 0) ? _c('group', {
    attrs: {
      "title": "爱眼日活动参与编号"
    }
  }, [_c('x-button', {
    attrs: {
      "gradients": ['#FF5E3A', '#FF9500']
    }
  }, [_vm._v("\n                活动编号：\n                "), _c('countup', {
    staticClass: "demo1",
    attrs: {
      "start-val": 1000,
      "end-val": _vm.subOrderId,
      "decimals": 0,
      "duration": 1
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "title": "产品信息"
    }
  }, _vm._l((_vm.productList), function(i) {
    return _c('cell', {
      key: i.id,
      attrs: {
        "title": i.title,
        "value": "x " + i.number
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-right": "5px"
      },
      attrs: {
        "slot": "icon",
        "width": _vm.iconWidth,
        "height": _vm.iconWidth,
        "src": _vm.tianYiWebUrl + i.img
      },
      slot: "icon"
    })])
  })), _vm._v(" "), (!_vm.isSelfOrder) ? _c('group', {
    attrs: {
      "title": "购买者/收货地信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": _vm.order.uid,
      "inline-desc": _vm.address.provence + "-" + _vm.address.city + "-" + _vm.address.region
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v("ID: " + _vm._s(_vm.order.uid))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfo.nick_name))])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "border-radius": "25px",
      "padding-right": "3px"
    },
    attrs: {
      "slot": "icon",
      "src": _vm.userInfo.headimgurl,
      "width": "50",
      "alt": ""
    },
    slot: "icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isSelfOrder && _vm.address !== '') ? _c('group', {
    attrs: {
      "title": "收货地址"
    }
  }, [_c('cell', {
    attrs: {
      "title": _vm.address.name + ' (' + _vm.address.tel + ')',
      "inline-desc": _vm.address.provence + _vm.address.city + _vm.address.region + _vm.address.street
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/dizhiicon.png"),
      "width": "30",
      "alt": ""
    },
    slot: "icon"
  })])], 1) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "title": "快递信息(点击单号可查询快递)"
    }
  }, _vm._l((_vm.expresses), function(item) {
    return _c('cell', {
      key: item.sn,
      attrs: {
        "title": "快递单号",
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.gotoKuaiDi100(item.sn)
        }
      }
    }, [_vm._v(" " + _vm._s(item.sn) + "\n            ")])
  })), _vm._v(" "), _c('group', {
    attrs: {
      "title": "订单信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单ID",
      "value": _vm.order.id
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "产品金额"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "darkgreen"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v("¥ " + _vm._s((_vm.order.total_price - _vm.order.discount_amount).toFixed(2)) + " 元")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "加购金额"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "darkgreen"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v("¥ " + _vm._s((_vm.order.addon_product_price - 0).toFixed(2)) + " 元")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "邮费"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "darkgreen"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v("¥ " + _vm._s((_vm.order.ship_fee).toFixed(2)) + " 元")])]), _vm._v(" "), (_vm.order.discount_amount > 0) ? _c('cell', {
    attrs: {
      "title": "优惠金额"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v("¥ " + _vm._s(_vm.order.discount_amount) + " 元")])]) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "总数量",
      "value": ("x " + (_vm.order.total_number))
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "订单状态"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0F769F"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v("[" + _vm._s(_vm.order.order_status) + "] [" + _vm._s(_vm.order.express_status) + "]")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "下单时间",
      "value": _vm.order.create_time
    }
  }), _vm._v(" "), (_vm.order.create_time <= _vm.order.paid_time) ? _c('cell', {
    attrs: {
      "title": "支付时间",
      "value": _vm.order.paid_time
    }
  }) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "支付方式",
      "value": _vm.paymentText(_vm.order.payment_method)
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "备注",
      "value": _vm.order.user_remark
    }
  })], 1), _vm._v(" "), _c('group', [(_vm.order.order_status === '未付款' && _vm.order.is_agent_order && _vm.order.total_price == 0) ? _c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.paymentList.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.agentPay()
      }
    }
  }, [_vm._v("立即提货\n            ")]) : _vm._e(), _vm._v(" "), (_vm.order.order_status === '未付款' && _vm.order.total_price != 0) ? _c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.paymentList.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.makePayment = true
      }
    }
  }, [_vm._v(_vm._s(_vm.payBtnText) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.order.order_status === '新订单') ? _c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel(_vm.order.id)
      }
    }
  }, [_vm._v("取消订单\n            ")]) : _vm._e(), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "BACK"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "menus": _vm.payment,
      "close-on-clicking-mask": false,
      "close-on-clicking-menu": true
    },
    on: {
      "on-click-menu-wechat": _vm.payWechat,
      "on-click-menu-balance": _vm.payBalance,
      "on-click-menu-cancel": function($event) {
        _vm.makePayment = false
      }
    },
    model: {
      value: (_vm.makePayment),
      callback: function($$v) {
        _vm.makePayment = $$v
      },
      expression: "makePayment"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.payHeader)
    },
    slot: "header"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361e8d8e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/OrderDetail.vue
// module id = 666
// module chunks = 0